import { memo } from 'react';

import { ShareDesignColorRow } from '~/components/ShareModal/components/ShareDesignColorRow';
import { useCreateShowcaseDesign } from '~/components/ShowcaseModal/CreateShowcaseDesignProvider';

/** "Page background" color swatch row, bound to the design context. */
export const CreateShowcaseDesignPageBackgroundRow = memo(() => {
  const {
    colorRoles,
    getColorRowProps,
    brandCustomizationEnabled,
    brandingDisabled,
    handleClearTransientColor,
    handlePreviewChange,
    handleResetColor,
    handleCommitColor,
    handleCommitBrandColor,
    brandColors,
  } = useCreateShowcaseDesign();

  const role = colorRoles.find((colorRole) => colorRole.readKey === 'pageBgColor');

  if (!role) {
    return null;
  }

  const { displayHex, isCustomColor, selectedBrandColorId } = getColorRowProps(role);

  return (
    <ShareDesignColorRow
      brandColors={brandColors}
      // Disable while a save is in flight: each save sends a full-replacement customColors
      // object, so overlapping saves could clobber each other (out-of-order responses
      // wholesale-replace the stored colors). Serializing saves avoids that.
      disabled={brandingDisabled}
      displayHex={displayHex}
      isCustomColor={isCustomColor}
      onDiscard={handleClearTransientColor}
      onPreviewChange={handlePreviewChange}
      onReset={handleResetColor}
      onSave={handleCommitColor}
      onSaveBrandColor={handleCommitBrandColor}
      role={role}
      selectedBrandColorId={selectedBrandColorId}
      // Upsell reflects only the plan gate, never the in-flight disabled state.
      showUpsell={!brandCustomizationEnabled}
    />
  );
});

CreateShowcaseDesignPageBackgroundRow.displayName = 'CreateShowcaseDesignPageBackgroundRow';
